// eslint-disable-next-line import/no-unresolved
import engine from './platform/default/fireboltMetrics.engine';

export const engineName = 'fireboltMetrics';

export const getEngine = () => ({
  thirdPartyServiceConfig: {
    key: engineName,
    name: engineName,
    bootMethod: () => {},
    engine: () => engine,
    initParams: {},
  },
  cleanup: () => {},
});
